import * as mobx from 'mobx';
import { ConnectionEntity } from './abstract-connection.entity';

type EntityId = number;
type EntityCollection<T> = Record<EntityId, ConnectionEntity<T>>;

export abstract class ConnectionEntityAggregate<T, C> extends ConnectionEntity<T> {
    @mobx.observable
    private entities: EntityCollection<C> = {};

    protected constructor(_key: string, props: Partial<T>) {
        super(_key, props);
    }

    @mobx.action
    public setEntity(id: EntityId, entity: ConnectionEntity<C>): void {
        this.entities[id] = entity;
    }
    @mobx.action
    public removeEntity(id: EntityId): void {
        delete this.entities[id];
    }

    @mobx.action
    public invalidateAssignedConnectionById(id: number): void {
        super.invalidateAssignedConnectionById(id);
        this.getEntities().forEach(entity => entity.invalidateAssignedConnectionById(id));
    }

    public getEntity(id: EntityId): ConnectionEntity<C> | null {
        return this.entities[id] ?? null;
    }
    public getEntities(): ConnectionEntity<C>[] {
        return Object.values(this.entities);
    }
}
